import 'preline/dist/preline';
import './App.css';
import Header from './components/Header';
import ParallaxWrapper from './components/ParallaxWrapper';
import Footer from './components/Footer';
import AppRoutes from './AppRoutes';
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported, logEvent, setAnalyticsCollectionEnabled, setConsent } from 'firebase/analytics';
import type { Analytics } from 'firebase/analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CookieBanner from './components/CookieBanner';
import { useCookieConsent } from './global/cookieConsent';

const firebaseConfig = {
    apiKey: "AIzaSyBJZy46Ib9QA_J9iQm2E1KTgu4aulinZNk",
    authDomain: "flag-site.firebaseapp.com",
    projectId: "flag-site",
    storageBucket: "flag-site.appspot.com",
    messagingSenderId: "160084187973",
    appId: "1:160084187973:web:922eec2ca54bd7c5867c2c",
    measurementId: "G-GSHBF8BFSD"
};
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
let analytics: Analytics | null = null;


function App() {
  const location = useLocation();
  const { consent } = useCookieConsent();

  useEffect(() => {
    let active = true;

    const updateAnalytics = async () => {
      if (consent === 'accepted' && await isSupported()) {
        analytics = analytics || getAnalytics(app);
        setConsent({
          analytics_storage: 'granted',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        });
        setAnalyticsCollectionEnabled(analytics, true);
        if (active) logEvent(analytics, 'page_view', { page_path: location.pathname + location.search });
      } else if (consent === 'refused' && analytics) {
        setConsent({analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'});
        setAnalyticsCollectionEnabled(analytics, false);
      }
    };

    updateAnalytics();
    return () => { active = false; };
  }, [consent, location.pathname, location.search]);
    return (
        <div className="flex flex-1 flex-col">
            <ParallaxWrapper
                bgImages={[
                    require('./assets/background.jpg'),
                ]}
            >
                <div className='z-10'>
                    <Header />
                </div>
                <AppRoutes />
                <Footer/>
                <CookieBanner />
            </ParallaxWrapper>
        </div>
    );
}

export default App;
